import Modal from './modal';

export * from './modal';
export default Modal;
